export enum LocalStorageKeys {
  token = '@meapoia.com:token',
}

export enum SessionStorageKeys {
  registerFlow = '@meapoia.com:register-flow',
  timestamp = '@meapoia.com:countdown',
}
